module.exports = __webpack_public_path__ + "static/media/dice.81334904.webp";